<template>
  <div class="wrapper">
    <div class="content-left">
      <div class="content-search">
        <input v-model="keyword" placeholder="请输入地区名称搜索"/>
        <img src="../../../assets/images/bigData/search.png" @click="pageNumber=1;chooseId='';getList()"/>
      </div>
      <div class="left-content" @scroll="searchListScroll">
        <div
          class="left-content-one"
          :class="{'left-content-one-choose':chooseId===item.id}"
          v-for="(item,index) in list"
          :key="index"
          @click="chooseOne(item.id)">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="content-right">
      <div class="content-right-one" v-for="(item,index) in rightList" :key="index">
        <div style="width: calc(100% - 0.36rem);height: calc(100% - 5.09rem)">
          <iframe width="100%" height="100%"
                  :src="'https://open.ys7.com/ezopen/h5/iframe?url=' + item.monitorUrl + '&autoplay=1&accessToken=' + item.accessToken"></iframe>
        </div>
        <div class="content-right-one-title">{{ item.monitorName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  components: {},
  data() {
    return {
      keyword: '',
      list: [],
      pageNumber: 1,
      chooseId: '',
      rightList: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    ...mapActions(['getSumCenterList', 'queryMoniterList', 'YSAccessToken', 'getMoniterList']),
    ...mapMutations(['goToPage']),
    getList() {
      this.getSumCenterList({
        name: this.keyword,
        pageNum: this.pageNumber,
        pageSize: 20,
        hasTenant: true,
        hasMonitor:true
      }).then(res => {
        if (res.code === 200) {
          if (this.pageNumber === 1) {
            this.list = res.data.records
            this.rightList = []
          } else {
            this.list = this.list.concat(res.data.records)
          }
        }
      })

      this.getMoniterList({
        pageNum: 1,
        pageSize: 4
      }).then(res => {
        this.rightList = res.data
        this.rightList.forEach(item => {
          this.getAccessToken(item.id).then((res) => {
            this.$set(item, 'accessToken', res)
          })
        })
      })
    },

    /**
     * 左侧搜索滚动到底部
     */
    searchListScroll() {
      this.$nextTick(() => {
        const el = document.querySelector('.left-content')
        const offsetHeight = el.offsetHeight
        el.onscroll = () => {
          const scrollTop = el.scrollTop
          const scrollHeight = el.scrollHeight
          if ((offsetHeight + scrollTop) - scrollHeight >= -1) {
            this.pageNumber++
            this.getList()
          }
        }
      })
    },

    chooseOne(id) {
      this.chooseId = id
      const params = {
        cmId: this.chooseId
      }
      this.moniterData = []
      this.queryMoniterList(params).then(res => {
        this.rightList = res.data
        this.rightList.forEach(item => {
          this.getAccessToken(item.id).then((res) => {
            this.$set(item, 'accessToken', res)
          })
        })
      })
    },

    getAccessToken(id) {
      const params = {
        id: id
      }
      return new Promise((resolve, reject) => {
        this.YSAccessToken(params).then(res => {
          resolve(res.data)
        }).catch(error => {
          reject(error)
        })
      })
    }

  }
}
</script>

<style scoped>

.wrapper {
  padding: 0;
  width: 100%;
  height: 100%;
  min-height: 600px;
  background: url('../../../assets/images/bigData/bg.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
}

.content-left {
  display: flex;
  width: 25.45rem;
  flex-direction: column;
  margin: 4.36rem 0 0 3.82rem;;
}

.content-search {
  width: 25.45rem;
  height: 5.09rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 38, 61, 0);
  border: 0.09rem solid #00D8FF;
}

.content-search > input {
  flex: 1;
  margin: 0 2.18rem;
  color: #00A3C0;
  background: rgba(255, 255, 255, 0);
  border: none;
}

.content-search > img {
  width: 2.18rem;
  height: 2.18rem;
  margin-right: 2.18rem;
}

input::placeholder {
  font-size: 1.45rem;
  color: #007D93;
}

input:focus {
  outline: none;
}

.left-content {
  height: calc(100vh - 16.36rem);
  width: 25.45rem;
  overflow-y: auto;
  background: rgba(2, 38, 61, 0.6);
  border: 0.09rem solid #00D8FF;
  margin-top: 1.82rem;
}

.left-content::-webkit-scrollbar {
  display: none; /* 对于Chrome, Safari */
}

.left-content-one:first-child {
  margin-top: 1.82rem;
}

.left-content-one {
  height: 5.09rem;
  line-height: 5.09rem;
  color: #00D8FF;
  padding: 0 2.18rem;
  text-overflow: ellipsis;
  white-space: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 1.82rem;
}

.left-content-one-choose {
  background: #00D8FF;
  color: #02263D !important;
}

.content-right {
  margin: 4.36rem 0 0 1.82rem;
  display: flex;
  flex-wrap: wrap;
  width: calc(100vw - 31.09rem);
}

.content-right-one {
  width: calc((100vw - 36.72rem) / 2);
  height: 43.64rem;
  background: rgba(2, 38, 61, 0.7);
  border: 0.09rem solid #00D8FF;
  margin-right: 1.45rem;
}

.content-right-one-title {
  height: 5.09rem;
  line-height: 5.09rem;
  background: rgba(0, 216, 255, 0.4);
  padding: 0 2.18rem;
  color: #00D8FF;
  font-size: 1.82rem;
}
</style>
